import React, { useEffect, useState } from "react";
import { Dimensions, Platform, View, useWindowDimensions, } from "react-native";
import { withTheme } from "@rneui/themed";
import { Carousel as CarouselBase, } from "../base/Carousel";
import { CarouselSlide } from "./CarouselSlide";
import { Image as SkeletonImage } from "../../skeleton";
import { getImageSize } from "../../..";
import { isAdvancedCarousel } from "../utils";
export const UnthemedCarousel = ({ carousel, isLoading, style, carouselContainerStyle, ...rest }) => {
    const dims = useWindowDimensions();
    const height = Platform.select({
        web: "34vw",
        default: dims.width / 3,
    });
    const defaultDimensions = {
        width: dims.width,
        height: dims.width / 3,
    };
    const [widthConstraint, setWidthConstraint] = useState(Dimensions.get("window").width);
    const isSingle = carousel.slides?.length === 1;
    const isAdvanced = isAdvancedCarousel(carousel);
    const [aspectRatio, setAspectRatio] = useState(1);
    useEffect(() => {
        if (!carousel.slides || isAdvanced)
            return;
        const findMinAspect = async () => {
            let minAspect = undefined;
            for (const slide of carousel.slides) {
                if (!slide.cover?.src)
                    continue;
                console.log(slide.cover.src);
                const imageDims = await getImageSize(slide.cover.src).start();
                if (!imageDims)
                    continue;
                const ratio = imageDims.width / imageDims.height;
                if (minAspect && minAspect <= ratio)
                    continue;
                minAspect = ratio;
            }
            if (minAspect) {
                setAspectRatio(minAspect);
            }
        };
        findMinAspect();
    }, [carousel.slides, isAdvanced]);
    return (React.createElement(View, { style: style, onLayout: ({ nativeEvent: { layout: { width }, }, }) => setWidthConstraint(width) }, isLoading ? (React.createElement(View, { style: { marginBottom: 20 } },
        React.createElement(SkeletonImage, { width: "100%", height: height }))) : isSingle ? (React.createElement(CarouselSlide, { slide: carousel.slides[0], defaultDimensions: defaultDimensions, widthConstraint: widthConstraint, extendedImages: carousel.extendedImages, displayCarded: carousel.displayCarded, isAdvanced: isAdvanced })) : (React.createElement(CarouselBase, { ...rest, style: carouselContainerStyle, displayCarded: carousel.displayCarded, extendedImages: carousel.extendedImages, data: carousel.slides, contentWidth: widthConstraint, contentHeight: isAdvanced ? undefined : widthConstraint / aspectRatio, renderItem: ({ item }) => (React.createElement(CarouselSlide, { slide: item, defaultDimensions: defaultDimensions, widthConstraint: widthConstraint, extendedImages: carousel.extendedImages, displayCarded: carousel.displayCarded, isAdvanced: isAdvanced })) }))));
};
export const Carousel = withTheme(UnthemedCarousel, "CarouselStandard");
//# sourceMappingURL=Carousel.js.map